export default "__VITE_ASSET__MirEQofS__"